import { useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";

import { GlobalContext } from "../../context/GlobalContext";
import { GET_HEALTH_FORM } from "../../Graphql/queries/queryGetHealthForm";
import { LoadingScreen } from "../../components/StatusScreens/LoadingScreen";
import { RoutesNames } from "../../components/utils/routes";
import { useRedirectLogged } from "../../Hooks/useRedirectLogged";
import { useToastError } from "../../Hooks/useToastError";
import { Variables } from "../../styles/Variables";
import ExportExcel from "../../components/OptionList/ExportExcel";
import HeaderMain from "../../components/header/headerMain";
import IconInfo from "../../components/Icons/IconInfo";
import ModalInformation from "../../Modals/ModalInformation";
import OptionHealth from "../../components/OptionList/OptionHealth";

import {
  ContainerContent,
  ContainerTable,
  ContainerHeader,
  ContainerData,
  HeaderOptions,
  ContainerIcon,
  ContainerOptionAndExport,
  ContainerOptionHeader,
  InfoText,
  ContainerGlobal,
  ContainFieldHeader,
} from "../../styles/PageStyles/Health/stylesRegistersHealth";

const RegistersHealthStandard = () => {
  useRedirectLogged();
  const navigate = useNavigate();
  const { rol } = useContext(GlobalContext);

  useEffect(() => {
    if (!rol) {
      navigate(RoutesNames.login);
    }
  }, [rol, navigate]);

  const [showInfo, setShowInfo] = useState(false);
  const [colorSelect, setColorSelect] = useState("NA");

  const [getHealthForm, { error, data, loading }] = useLazyQuery(GET_HEALTH_FORM, {
    variables: {
      affiliated: null,
      noAffiliate: "NOT_AFFILIATE",
      pending: "PENDING_REQUEST",
    },
  });

  useToastError(error);

  useEffect(() => {
    getHealthForm();
  }, [getHealthForm]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <ContainerGlobal>
      <HeaderMain />
      <ContainerContent>
        <HeaderOptions>
          <ContainerIcon onClick={() => setShowInfo(!showInfo)}>
            <IconInfo />
          </ContainerIcon>
          <ModalInformation modalOpen={showInfo} setModalOpen={setShowInfo}>
            <div>
              <InfoText>
                Los datos suministrados a continuación corresponden a los ingresados por usuarios en el paso número 4,
                del portal de ayuda a migrantes, los cuales deberán ser validados y verificados por cada territorial.
              </InfoText>
              <InfoText>
                Si tienes dificultades con el uso de la plataforma por favor informar al correo electrónico
                admon@integracionmigrante.com
              </InfoText>
            </div>
          </ModalInformation>
          <ContainerOptionAndExport>
            <ContainerOptionHeader
              style={
                colorSelect === "NA"
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: 200,
                      height: 25,
                      color: Variables.colorGreenSuccess,
                      borderWidth: 2,
                      borderColor: Variables.colorWhite,
                      borderStyle: "solid",
                      borderRadius: 10,
                      textAlign: "center",
                    }
                  : null
              }
              onClick={() => {
                setColorSelect("NA");
                getHealthForm({
                  variables: {
                    affiliated: null,
                    noAffiliate: "NOT_AFFILIATE",
                    pending: "PENDING_REQUEST",
                  },
                });
              }}
            >
              No afiliados / Pendientes
            </ContainerOptionHeader>
            {colorSelect === "NA" && <ExportExcel arrayData={data?.getHealthUser} />}
          </ContainerOptionAndExport>
          <ContainerOptionAndExport>
            <ContainerOptionHeader
              style={
                colorSelect === "AF"
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: 200,
                      height: 25,
                      color: Variables.colorGreenSuccess,
                      borderWidth: 2,
                      borderColor: Variables.colorWhite,
                      borderStyle: "solid",
                      borderRadius: 10,
                      textAlign: "center",
                    }
                  : null
              }
              onClick={() => {
                setColorSelect("AF");
                getHealthForm({
                  variables: {
                    affiliated: "AFFILIATE",
                    noAffiliate: null,
                    pending: null,
                  },
                });
              }}
            >
              Afiliados
            </ContainerOptionHeader>
            {colorSelect === "AF" && <ExportExcel arrayData={data?.getHealthUser} />}
          </ContainerOptionAndExport>
        </HeaderOptions>
        <ContainerTable>
          <ContainerHeader>
            <ContainFieldHeader>ESTADO</ContainFieldHeader>
            <ContainFieldHeader>FECHA DE INSCRIPCIÓN</ContainFieldHeader>
            <ContainFieldHeader>NOMBRE</ContainFieldHeader>
            <ContainFieldHeader>APELLIDO</ContainFieldHeader>
            <ContainFieldHeader>DEPARTAMENTO</ContainFieldHeader>
            <ContainFieldHeader>MUNICIPIO</ContainFieldHeader>
          </ContainerHeader>
          <ContainerData>
            {data?.getHealthUser.map((item) => (
              <OptionHealth item={item} key={item.id} />
            ))}
          </ContainerData>
        </ContainerTable>
      </ContainerContent>
    </ContainerGlobal>
  );
};

export default RegistersHealthStandard;
